'use client';
import React, { useState } from 'react';
import { CATEGORIES, CITIES } from '@/lib/mockData';
import { Filter, MapPin, Tag, ArrowUpDown } from 'lucide-react';

type Props = {
  onFilterChange?: (filters: { category: string; city: string; sort: string }) => void;
};

export default function StoreFilters({ onFilterChange }: Props) {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedCity, setSelectedCity] = useState('All Cities');
  const [sortBy, setSortBy] = useState('trust_score');

  const handleCategoryChange = (cat: string) => {
    setSelectedCategory(cat);
    // Backend integration: GET /api/stores?category=cat
  };

  return (
    <div className="mb-8">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
          <Filter size={16} />
          <span>Filters:</span>
        </div>

        {/* Category chips */}
        <div className="flex flex-wrap gap-2">
          {['All', ...CATEGORIES].map((cat) => (
            <button
              key={`chip-${cat}`}
              onClick={() => handleCategoryChange(cat)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all duration-150 active:scale-95
                ${selectedCategory === cat
                  ? 'bg-primary text-primary-foreground border-primary shadow-sm'
                  : 'bg-card text-muted-foreground border-border hover:border-primary hover:text-primary'
                }`}
            >
              <Tag size={11} />
              {cat}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-4">
        {/* City filter */}
        <div className="flex items-center gap-2 bg-card border border-border rounded-xl px-3 py-2">
          <MapPin size={14} className="text-muted-foreground" />
          <select
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            className="text-sm text-foreground bg-transparent outline-none cursor-pointer"
            aria-label="Filter by city"
          >
            <option value="All Cities">All Cities</option>
            {CITIES.map((city) => (
              <option key={`city-${city}`} value={city}>{city}</option>
            ))}
          </select>
        </div>

        {/* Sort */}
        <div className="flex items-center gap-2 bg-card border border-border rounded-xl px-3 py-2">
          <ArrowUpDown size={14} className="text-muted-foreground" />
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="text-sm text-foreground bg-transparent outline-none cursor-pointer"
            aria-label="Sort stores"
          >
            <option value="trust_score">Highest Trust Score</option>
            <option value="rating">Highest Rating</option>
            <option value="newest">Newest First</option>
            <option value="name">Name A–Z</option>
          </select>
        </div>

        <p className="ml-auto text-sm text-muted-foreground font-medium">
          Showing <span className="text-foreground font-semibold">12</span> verified stores
        </p>
      </div>
    </div>
  );
}